<template>
  <div class='product-ingredient-see-ocr--container'>
    <el-drawer :visible.sync='show' :close-on-press-escape='false' :title="`${info.title}_文本识别结果`"
               append-to-body
               custom-class='product-ingredient-see-ocr-drawer'>
      <div class='content'>
        <div id="OcrContent">
          <div v-if="!Array.isArray(info.ingredient_url) || !info.ingredient_url.length">无</div>
          <div v-else style="height: calc(100vh - 144px);">
            <div class="ocr-layout">
              <!-- 左侧图片展示区域 -->
              <div class="image-section">
                <!-- 大图展示区域 -->
                <div class="large-image-container">
                  <el-image
                    :src="currentImage.url"
                    :preview-src-list="[currentImage.url]"
                    fit="contain"
                    class="large-image">
                  </el-image>
                  <!-- 图片切换按钮 -->
                  <div class="image-nav">
                    <el-button
                      size="mini"
                      :disabled="currentIndex === 0"
                      @click="prevImage">
                      <i class="el-icon-arrow-left"></i>
                    </el-button>
                    <span class="image-counter">{{ currentIndex + 1 }} / {{ info.ingredient_url.length }}</span>
                    <el-button
                      size="mini"
                      :disabled="currentIndex === info.ingredient_url.length - 1"
                      @click="nextImage">
                      <i class="el-icon-arrow-right"></i>
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- 右侧表格展示区域 -->
              <div class="table-section">
                <p style="font-weight: 600;">
                  第&nbsp;<b style="color: #ff3176;font-size: 20px;">{{ currentIndex + 1 }}</b>&nbsp;张图片识别内容
                </p>
                <el-table :data="tableData" border style="width: 100%;" height="calc(100% - 55px)">
                  <el-table-column type="index" label="序号" width="50" align="center" />
                  <el-table-column prop="content" label="识别内容" min-width="200" />
                  <el-table-column
                    prop="accuracy"
                    label="精准度"
                    width="80"
                    align="center">
                    <template slot-scope="scope">
                      <el-tag
                        :type="getAccuracyType(scope.row.accuracy)"
                        size="small">
                        {{ (scope.row.accuracy * 100).toFixed(1) }}%
                      </el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 小图缩略图区域 -->
            <div class="thumbnail-container__outer">
              <div class="thumbnail-container">
                <div
                  v-for="(item, index) in info.ingredient_url"
                  :key="index"
                  class="thumbnail-item"
                  :class="{ active: currentIndex === index }"
                  @click="switchImage(index)">
                  <el-image
                    :src="item.url"
                    fit="cover"
                    class="thumbnail-image">
                  </el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style='height: 80px;' />
      <div class='footer'>
        <el-button @click="show=false">关闭</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>

import MlInput from '../../../components/MlInput/index.vue'
import MlButton from '../../../components/MlButton/index.vue'

export default {
  name: 'ProductIngredientSeeOcr',
  components: { MlButton, MlInput },
  data() {
    return {
      loading: false,
      show: false,
      info: {},
      currentIndex: 0
    }
  },
  computed: {
    currentImage() {
      if (!Array.isArray(this.info.ingredient_url) || !this.info.ingredient_url.length) {
        return { url: '' }
      }
      return this.info.ingredient_url[this.currentIndex]
    },
    tableData() {
      if (!this.info.ingredient_proto || !Array.isArray(this.info.ingredient_proto[0])) {
        return []
      }

      const contents = this.info.ingredient_proto[2 * this.currentIndex]
      const accuracies = this.info.ingredient_proto[2 * this.currentIndex + 1] || []

      return contents.map((content, index) => ({
        content: content,
        accuracy: accuracies[index] || 0
      }))
    }
  },
  methods: {
    /**
     * 给父组件用
     * @param obj
     */
    interfaceSee: function(obj) {
      this.handleShowDrawer(obj)
    },
    /**
     * 弹出层
     * @param obj
     */
    handleShowDrawer: async function(obj) {
      this.info = obj
      this.show = true
      this.currentIndex = 0
    },
    /**
     * 切换到上一张图片
     */
    prevImage() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    /**
     * 切换到下一张图片
     */
    nextImage() {
      if (this.currentIndex < this.info.ingredient_url.length - 1) {
        this.currentIndex++
      }
    },
    /**
     * 通过点击缩略图切换图片
     * @param {number} index
     */
    switchImage(index) {
      this.currentIndex = index
    },
    /**
     * 根据精准度返回标签类型
     * @param {number} accuracy
     * @returns {string}
     */
    getAccuracyType(accuracy) {
      if (accuracy >= 0.9) return 'success'
      if (accuracy >= 0.7) return 'warning'
      return 'danger'
    }
  }
}
</script>

<style lang='scss'>
.product-ingredient-see-ocr--container {
  display: inline;
}

.product-ingredient-see-ocr-drawer {
  width: 60% !important;

  .el-drawer__title {
    border-top-left-radius: 10px !important;
  }

  .el-drawer__header {
    font-size: 16px !important;
    color: #333333 !important;
    font-weight: 700;
    text-align: center;
  }

  .el-drawer__body {
    border-bottom-left-radius: 10px !important;
    padding: 0 20px;
    overflow: hidden;
  }
  .thumbnail-container__outer {
    display: flex;
    align-content: center;
    justify-content: center;
  }

  .thumbnail-container {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding: 8px 0;

    .thumbnail-item {
      width: 80px;
      height: 80px;
      border: 2px solid transparent;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s ease;
      flex-shrink: 0;

      &.active {
        border-color: #ff3176;
        box-shadow: 0 2px 8px rgba(255, 49, 118, 0.67);
      }

      &:hover:not(.active) {
        border-color: #c0c4cc;
      }

      .thumbnail-image {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
  }

  /* OCR 布局样式 */
  .ocr-layout {
    display: flex;
    gap: 20px;
    height: calc(100% - 120px);

    .image-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .large-image-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        //border: 1px solid #e0e0e0;
        border-radius: 8px;
        overflow: hidden;
        background: #f8f9fa;

        .large-image {
          flex: 1;
          width: 100%;
          height: 100%;
          min-height: 300px;
        }

        .image-nav {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px;
          background: #fff;
          border-top: 1px solid #e0e0e0;
          gap: 16px;

          .image-counter {
            font-size: 14px;
            color: #666;
            font-weight: 500;
          }

          .el-button {
            border-radius: 50%;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }

    }


    .table-section {
      flex: 1;
      //border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 4px 16px;

      .el-table {
        //border-radius: 8px;

        .el-table__header-wrapper {
          //background: #f5f7fa;
        }

        .el-table__body-wrapper {
          //max-height: 400px;
          overflow-y: auto !important;
        }
      }
    }
  }

  /* Markdown 样式 */
  .content {
    h1, h2, h3, h4, h5, h6 {
      margin: 16px 0 8px 0;
      color: #333;
      font-weight: 600;
    }

    h1 {
      font-size: 24px;
    }

    h2 {
      font-size: 20px;
    }

    h3 {
      font-size: 18px;
    }

    h4 {
      font-size: 16px;
    }

    h5 {
      font-size: 14px;
    }

    h6 {
      font-size: 12px;
    }

    p {
      margin: 8px 0;
      line-height: 1.6;
      color: #666;
    }

    ul, ol {
      margin: 8px 0;
      padding-left: 24px;
    }

    li {
      margin: 4px 0;
      line-height: 1.6;
    }

    strong {
      font-weight: 600;
      color: #333;
    }

    em {
      font-style: italic;
    }

    code {
      background-color: #f5f5f5;
      padding: 2px 6px;
      border-radius: 3px;
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 0.9em;
    }

    pre {
      background-color: #f5f5f5;
      padding: 12px;
      border-radius: 4px;
      overflow-x: auto;
      margin: 12px 0;

      code {
        background: none;
        padding: 0;
      }
    }

    blockquote {
      border-left: 4px solid #ddd;
      padding-left: 16px;
      margin: 12px 0;
      color: #666;
      font-style: italic;
    }

    a {
      color: #1890ff;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    //table {
    //  width: 100%;
    //  border-collapse: collapse;
    //  //margin: 12px 0;
    //
    //  th, td {
    //    padding: 8px 12px;
    //    border: 1px solid #ddd;
    //  }
    //
    //  th {
    //    background-color: #f5f5f5;
    //    font-weight: 600;
    //  }
    //}
  }
}
</style>
